import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../lib/i18n";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { t, lang } = useLang();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden">
      <img
        src="https://images.pexels.com/photos/31737860/pexels-photo-31737860.jpeg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/60" />
      <div className="relative z-10 w-full max-w-md bg-[#121212] border border-white/10 p-10 fade-up">
        <Link to="/" data-testid="login-back-home" className="inline-flex items-center gap-2 text-white/50 hover:text-gold text-sm mb-6 transition-colors">
          <ArrowLeft size={16} /> {lang === "en" ? "Back to home" : "Retour à l'accueil"}
        </Link>
        <a href="/" className="text-gold text-3xl font-display block text-center mb-2">KOILA <span className="text-xl text-white/50">Holdings</span></a>
        <h1 className="text-2xl font-display text-white text-center mb-2">{t("login_title")}</h1>
        <p className="text-white/50 text-sm text-center mb-8 leading-relaxed">{t("login_sub")}</p>
        <button
          data-testid="google-login-btn"
          onClick={handleGoogle}
          className="w-full flex items-center justify-center gap-3 bg-white text-black font-medium py-3 hover:bg-white/90 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
            <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l6.19 5.238C39.999 35.999 44 30.5 44 24c0-1.341-.138-2.65-.389-3.917z"/>
          </svg>
          {t("login_google")}
        </button>
      </div>
    </div>
  );
}
